<form [formGroup]="tecnicoFormGroup">
  <div class="row">
    <h4> Domicilio</h4>
  </div>
  <div class="row">
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaFormInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)">
    </rpe-direcciones-geograficas-form>
  </div>


  <div class="row">
    <h4> Contacto</h4>
  </div>

  <div class="row">
    <rpe-telefonos-form [formInput]="formInputTelefono" (formStatusChanges)="telefonoFormStatusChange($event)"
      (formValueChanges)="telefonoFormValueChange($event)"></rpe-telefonos-form>
  </div>

  <div class="row">
    <ng-container formGroupName="correo_electronico">
      <mat-form-field class="col-xs-12">
        <input matInput placeholder="Correo electrónico:" formControlName="direccion" required>
        <mat-error *ngIf="tecnicoFormGroup.get('correo_electronico')?.get('direccion').hasError('required')">
          Debe ingresar un correo electrónico
        </mat-error>
        <mat-error *ngIf="tecnicoFormGroup.get('correo_electronico')?.get('direccion').hasError('email')">
          Debe ingresar un correo electrónico válido (algo@correo.com)
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>

</form>